export enum LPTransactionType {
    RewardLPForMerchant = 'reward_merchant_lp',
    BuyLP = 'buy_lp',
    CashoutLP = 'cashout_lp',
    UpgradeLP = 'upgrade_lp',
  }